








import { computed, defineComponent } from '@vue/composition-api';

import useDeliveryNoteStatus from '@/useDeliveryNoteStatus';

const DeliveryNoteStatusRenderer = defineComponent({
  props: {
    status: { type: String, required: true },
    deliveries: { type: Array, required: false },
  },
  setup(props) {
    const { deliveryNoteStatusClassMap, translate } = useDeliveryNoteStatus();

    const computedFailureReasons = computed(() => {
      if (!props.deliveries || props.deliveries.length === 0) return '';
      let result = '';
      props.deliveries.forEach((delivery: any) => {
        result += `${delivery.failureReason ? `${delivery.failureReason}, ` : ''}`;
      });
      return result;
    });

    return {
      translate,
      deliveryNoteStatusClassMap,
      computedFailureReasons,
    };
  },
});

export default DeliveryNoteStatusRenderer;
